import type { CustomSEOPage } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';
import { processSeoVariables } from '@iheartjane/utils';

export function description(desc?: string) {
  if (!desc) return {};
  return {
    content: desc,
    name: 'description',
  };
}

export function getMetaDescription(
  customSEOPage?: Nullish<CustomSEOPage>,
  metaVariables: Record<string, string> = {}
) {
  return description(
    processSeoVariables(customSEOPage?.description, metaVariables)
  );
}
